<div class="mb-2">
  <mat-card>
    <mat-card-content>
      <mat-chip-set>
        @for (field of activeFields(); track field.name) {
          <app-filter-card-chip
            [field]="field"
            [value]="controls()[field.name].value"
            [oneOpenFormAtATime$]="manager().oneOpenFormAtATime$"
            (remove)="onChipRemove(field.name)"
            (edit)="onChipEdit(field.name, $event)"
          ></app-filter-card-chip>
        }

        <app-filter-card-add
          [pool]="pool()"
          [oneOpenFormAtATime$]="manager().oneOpenFormAtATime$"
          (add)="onAdd($event)"
          (draftingFieldChange)="addDraftFieldName.set($event)"
        ></app-filter-card-add>
      </mat-chip-set>
    </mat-card-content>
  </mat-card>

  @if (showApply | async) {
    <div class="my-3">
      <mat-card>
        <mat-card-content>
          <div class="d-flex flex-wrap align-items-center gap-5">
            <button mat-flat-button type="button" (click)="apply()">{{ 'button.update' | translate }}</button>
            @if (manager().hasSetAsDefault) {
              <button mat-stroked-button type="button" (click)="setAsDefault()">
                {{ 'button.setAsDefault' | translate }}
              </button>
            }
            <span class="p-xl-1 grey-text">{{ 'system.message.filterCardUpdateText' | translate }}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>
